import { Trans, useTranslation } from 'react-i18next';
import { Global, css } from '@emotion/react';
import { cn } from '@anytag/shared-utils';
import { TIKTOK_HELP_LINK } from '@anytag/shared-constants';
import { PaymentPlanType, usePricingTableQuery } from '@anytag/graphql';
import { tiktokInfluencerCampaignPlanBgImage } from '@anytag/shared-assets';
import { Icon, Anchor, RenderDataWithFallback } from '@anytag/shared-atoms';
import { Plan } from './Plan';

export const TikTokCampaignsPlansOnboarding = () => {
  const { t } = useTranslation();
  const { data, loading } = usePricingTableQuery({ variables: { planType: PaymentPlanType.TIKTOK_ADS } });

  const plans = data?.pricingTable?.plans.filter((plan) => plan.mkpCampaignEnabled) || [];

  return (
    <>
      {/* https://www.figma.com/design/SAiql1EuH80Pat9Zrg6dbj/AnyTag_Working?node-id=2923-16880&m=dev */}
      <Global
        styles={css({
          '.layout-wrapper': {
            padding: '0 !important',
            backgroundColor: 'rgba(22,28,34,0.85)',
            footer: { display: 'none' }
          }
        })}
      />

      <div className="m-auto w-max">
        <div
          style={{ backgroundImage: `url(${tiktokInfluencerCampaignPlanBgImage})` }}
          className="box-border min-h-47.5 rounded-t-[inherit] bg-white bg-cover bg-no-repeat pt-9.75 pr-9.75 pb-6 pl-6"
        >
          <div className="max-w-105 flex-1">
            <p className="mt-1.5 max-w-70 text-2xl font-normal">
              <Trans i18nKey="Boost your brand by running Influencer Campaigns" components={{ b: <b /> }} />
            </p>
            <p className="mt-1.5 text-sm font-normal text-black-60">{t('marketplacePlanDescription')}</p>
            <Anchor
              variant="inherit"
              href={TIKTOK_HELP_LINK.learnMoreAboutPlans}
              target="_blank"
              className="text-sm font-bold"
            >
              {t('Learn more about plans')}&nbsp;
              <Icon icon="caret-right" size={8} variant="inherit" />
            </Anchor>
          </div>
        </div>

        <div className="min-h-70 rounded-b-[inherit] bg-white">
          <RenderDataWithFallback loading={loading} loadingProps={{ className: cn('h-auto min-h-[inherit]') }}>
            <div className="box-border py-6 pr-2 pl-8">
              {plans.map((plan) => (
                <Plan key={plan.id} data={plan} />
              ))}
            </div>
          </RenderDataWithFallback>
        </div>
      </div>
    </>
  );
};
